import { useTranslations } from 'next-intl'

import { Form } from '@/shared/ui'

type Props = {
  placeholder?: string
  readOnly?: boolean
  disabled?: boolean
}

export const EmailField = ({
  placeholder,
  readOnly = false,
  disabled = false,
}: Props) => {
  const t = useTranslations('account')

  return (
    <Form.Field name="email" readOnly={readOnly} disabled={disabled}>
      <Form.Label className="font-medium text-black">
        {t('email_label')}
      </Form.Label>
      <Form.TextField
        type="email"
        placeholder={placeholder || t('email_placeholder')}
        fullWidth
        readOnly={readOnly}
        disabled={disabled}
      />
      <Form.Message />
    </Form.Field>
  )
}
